import {ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {AvstemningMedMøteModell, ManglerStemmegivningModell, TilgangsrolleMedlem} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {AvstemningManglerAndresStemmeKomponent} from "web-ng2/moduler/dashboard/komponenter/avstemning-mangler-andres-stemme/avstemning-mangler-andres-stemme";
import {AvstemningManglerBrukersStemmeKomponent} from "web-ng2/moduler/dashboard/komponenter/avstemning-mangler-brukers-stemme/avstemning-mangler-brukers-stemme";
import {toSignal} from "@angular/core/rxjs-interop";
import {map} from "rxjs/operators";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";

/** Panel som viser oversikt over avstemninger det skulle vært stemt på */
@Component({
    selector: 'avstemninger-popup',
    templateUrl: 'avstemninger-popup.html',
    styleUrl: 'avstemninger-popup.scss',
    standalone: true,
    imports: [TranslateModule, MatIcon, MatIconButton, AvstemningManglerAndresStemmeKomponent, AvstemningManglerBrukersStemmeKomponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvstemningerPopupKomponent {

    vedLukk = output<void>();

    avstemningerBrukerIkkeHarStemtPaa = input.required<AvstemningMedMøteModell[]>();
    avstemningerAndreIkkeHarStemtPaa = input.required<ManglerStemmegivningModell[]>();
    maksPopupHoeyde = input<number>(0);

    harSkrivetilgang = toSignal(this.kontekst.autentisertBrukerSomStrøm().pipe(map(bruker => bruker.inneharTilgangsrolleINoenGruppe(TilgangsrolleMedlem.skrive))), {initialValue: false});

    constructor(private kontekst: BrukerkontekstTilbyder) {
    }

    lukk() {
        this.vedLukk.emit();
    }

}
